module.exports = ["Resthöfe", "Resthof", "Rest"];



// WEBPACK FOOTER //
// ./src/data/rest.js